var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimalHealthIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9707 37.9707L37.9707 17.9707C38.9053 17.0549 39.649 15.9628 40.1589 14.7577C40.6687 13.5527 40.9347 12.2585 40.9413 10.95C40.9479 9.64152 40.6951 8.3447 40.1974 7.13454C39.6997 5.92439 38.967 4.82489 38.0418 3.89964C37.1165 2.97439 36.017 2.24174 34.8069 1.74405C33.5967 1.24637 32.2999 0.993518 30.9914 1.00013C29.6829 1.00673 28.3887 1.27267 27.1837 1.78256C25.9786 2.29244 24.8866 3.03616 23.9707 3.97071L3.97071 23.9707C3.03616 24.8866 2.29244 25.9786 1.78256 27.1837C1.27267 28.3887 1.00673 29.6829 1.00013 30.9914C0.993518 32.2999 1.24637 33.5967 1.74405 34.8069C2.24174 36.017 2.97439 37.1165 3.89964 38.0418C4.82489 38.967 5.92439 39.6997 7.13454 40.1974C8.3447 40.6951 9.64152 40.9479 10.95 40.9413C12.2585 40.9347 13.5527 40.6687 14.7577 40.1589C15.9628 39.649 17.0549 38.9053 17.9707 37.9707Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9707 13.9707L27.9707 27.9707",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimalHealthIcon);
export default __webpack_public_path__ + "static/media/Animal Health-icon.bf9970478566817cf3821e9f70d9967b.svg";
export { ForwardRef as ReactComponent };